import React from 'react';
import DetailPage from '../../components/DetailPage';

export default function AudioVisual() {
  return <DetailPage type="product" id="audio-visual" />;
}
